import { Expose } from 'class-transformer';

export class DvSignatureAccess {
  @Expose()
  signatureId: string;

  @Expose()
  accessCode: string;
}
